"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertJsonToFile = exports.uint8arrayToString = exports.uint8arrayFromString = exports.uint8ArrayToBase64 = exports.base64ToUint8Array = exports.utf8Decode = void 0;
function utf8Encode(str) {
    const utf8Array = [];
    for (let i = 0; i < str.length; i++) {
        let charCode = str.charCodeAt(i);
        if (charCode < 128) {
            utf8Array.push(charCode);
        }
        else if (charCode < 2048) {
            utf8Array.push(192 | (charCode >> 6), 128 | (charCode & 63));
        }
        else if ((charCode & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            charCode =
                0x10000 + ((charCode & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            utf8Array.push(240 | (charCode >> 18), 128 | ((charCode >> 12) & 63), 128 | ((charCode >> 6) & 63), 128 | (charCode & 63));
        }
        else {
            utf8Array.push(224 | (charCode >> 12), 128 | ((charCode >> 6) & 63), 128 | (charCode & 63));
        }
    }
    return new Uint8Array(utf8Array);
}
function utf8Decode(utf8Array) {
    let str = "";
    let i = 0;
    while (i < utf8Array.length) {
        let charCode = utf8Array[i++];
        if (charCode < 128) {
            str += String.fromCharCode(charCode);
        }
        else if (charCode > 191 && charCode < 224) {
            str += String.fromCharCode(((charCode & 31) << 6) | (utf8Array[i++] & 63));
        }
        else if (charCode > 239 && charCode < 365) {
            charCode =
                ((charCode & 7) << 18) |
                    ((utf8Array[i++] & 63) << 12) |
                    ((utf8Array[i++] & 63) << 6) |
                    (utf8Array[i++] & 63);
            charCode -= 0x10000;
            str += String.fromCharCode(0xd800 + (charCode >> 10), 0xdc00 + (charCode & 0x3ff));
        }
        else {
            str += String.fromCharCode(((charCode & 15) << 12) |
                ((utf8Array[i++] & 63) << 6) |
                (utf8Array[i++] & 63));
        }
    }
    return str;
}
exports.utf8Decode = utf8Decode;
function base64ToUint8Array(base64Str) {
    const binaryStr = atob(base64Str);
    const len = binaryStr.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryStr.charCodeAt(i);
    }
    return bytes;
}
exports.base64ToUint8Array = base64ToUint8Array;
function uint8ArrayToBase64(uint8Array) {
    const binaryStr = String.fromCharCode(...uint8Array);
    return btoa(binaryStr);
}
exports.uint8ArrayToBase64 = uint8ArrayToBase64;
function base64UrlPadToBase64(base64UrlPadStr) {
    return (base64UrlPadStr.replace("-", "+").replace("_", "/") +
        "=".repeat((4 - (base64UrlPadStr.length % 4)) % 4));
}
function base64ToBase64UrlPad(base64Str) {
    return base64Str.replace("+", "-").replace("/", "_").replace(/=+$/, "");
}
function uint8arrayFromString(str, encoding = "utf8") {
    switch (encoding) {
        case "utf8":
            return utf8Encode(str);
        case "base16": {
            const arr = [];
            for (let i = 0; i < str.length; i += 2) {
                arr.push(parseInt(str.slice(i, i + 2), 16));
            }
            return new Uint8Array(arr);
        }
        case "base64":
            return base64ToUint8Array(str);
        case "base64urlpad" || "base64url":
            return base64ToUint8Array(base64UrlPadToBase64(str));
        default:
            throw new Error(`Unsupported encoding "${encoding}"`);
    }
}
exports.uint8arrayFromString = uint8arrayFromString;
function uint8arrayToString(uint8array, encoding = "utf8") {
    const _uint8array = new Uint8Array(uint8array);
    switch (encoding) {
        case "utf8":
            return utf8Decode(_uint8array);
        case "base16":
            return Array.from(_uint8array)
                .map((byte) => byte.toString(16).padStart(2, "0"))
                .join("");
        case "base64":
            return uint8ArrayToBase64(_uint8array);
        case "base64urlpad":
            return base64ToBase64UrlPad(uint8ArrayToBase64(_uint8array));
        default:
            throw new Error(`Unsupported encoding "${encoding}"`);
    }
}
exports.uint8arrayToString = uint8arrayToString;
const convertJsonToFile = (jsonData, fileName) => {
    const blob = new Blob([JSON.stringify(jsonData)], {
        type: "application/json",
    });
    const file = new File([blob], fileName, { type: "application/json" });
    return file;
};
exports.convertJsonToFile = convertJsonToFile;
